import { uniq } from 'lodash';

import Notifier from '@/common/services/Notifier';
import { AccessInheritanceResponse } from '@/drive/types/AccessInheritanceResponse';

export function notifyAccessInheritanceWarnings(responses: AccessInheritanceResponse[]) {
  getAccessInheritanceErrors(responses).forEach((error) => Notifier.warn(error));
}

function getAccessInheritanceErrors(responses: AccessInheritanceResponse[]): string[] {
  const messages = responses.reduce<string[]>((errors, response) => {
    if (response.state === 'error' && response.error) {
      errors.push(response.error);
    }

    return errors;
  }, []);

  return uniq(messages);
}
